import { CompanySettings, LicenseTester } from "@mcleod/core";
import { DataSourceMode, DataSourceModeChangeEvent, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutLMEUserOperations } from "./autogen/AutogenLayoutLMEUserOperations";

export class LMEUserOperations extends AutogenLayoutLMEUserOperations {
    override onLoad() {
        this.setPartialShipmentFieldsVisibility();
        this.setSmsFieldsVisibility();
        this.showHideCompanyTypeBasedComponents();
    }

    private setPartialShipmentFieldsVisibility() {
        this.textboxPartialShipmentProfile.visible = CompanySettings.get().partial_shipment_enabled;
    }

    private setSmsFieldsVisibility() {
        if (!this.isSmsLicensed()) {
            this.textboxSmsMessageLimit.visible = false;
            this.textboxMessageVisibility.visible = false;
            this.textboxOptInDefault.visible = false;
        }
    }

    private isSmsLicensed(): boolean {
        return LicenseTester.testPackage("com.tms.client.loadmaster.sms");
    }

    private showHideCompanyTypeBasedComponents() {
        const companySettings = CompanySettings.get();
        const isAsset = companySettings?.is_asset;
        const isBrokerage = companySettings?.is_brokerage;
        const isBoth = isAsset && isBrokerage;

        this.textboxBpProfile.required = isBrokerage && !(isAsset && isBrokerage);

        if (isBoth) {
            this.textboxDefMoveType.visible = true;
            this.textboxBrokerageOrderNextAction.caption = "PowerBroker New Order Next Action";
            this.textboxAssetOrderNextAction.caption = "Loadmaster New Order Next Action";
        }
    }

    sourceUserSettingsAfterModeChange(event: DataSourceModeChangeEvent) {
        if (event.newMode == DataSourceMode.ADD || event.newMode == DataSourceMode.UPDATE) {
            const allocationEnabled = this.sourceUserSettings.activeRow?.get("seg_alloc_enabled") ?? false;
            this.textboxSegAllocCode.visible = allocationEnabled;
            delete this.sourceUserSettings.activeRow?.data["seg_alloc_enabled"];
        }
    }

    textboxTmProfileBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = 'Y';
    }

    textboxDetentionProfileIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.web_valid = true;
    }

    textboxSegAllocCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.alloc_type = 'M';
    }
}
